(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-preview/assets/javascripts/casino-game-preview-simple.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-preview/assets/javascripts/casino-game-preview-simple.js');

'use strict';

const {
  CardBody
} = svs.ui.ReactCard;
const {
  ReactIcon: Icon,
  ReactIconButton: IconButton,
  ReactButton: Button
} = svs.ui;
const {
  Link
} = ReactRouterDOM;
const {
  useSearchResults,
  useFavorites
} = svs.components.casino_react.casinoStore.hooks;
const {
  useState
} = React;
const {
  getAnalyticsPosition
} = svs.components.casino_react.analytics_utils.utils;
const {
  dispatchGameToLastSearched
} = svs.components.casino_react.casinoStore.utils.lastSearched;
const {
  CardType
} = svs.components.casino_react.common.constants;
const urlMapping = svs.core.urlMapping;
const {
  useLiveData
} = svs.components.casino_react.casino_store.hooks;
const {
  CasinoGamePlayers
} = svs.components.casino_react.casino_game_live_info;
const {
  startGameAsync
} = svs.components.casino.shared;
const {
  Loader
} = svs.components.ReactLoader;
const {
  CasinoGamePlayTypes
} = svs.components.casino_react.common.constants;
const cmsProviderList = svs.casino_react.shared.data.cmsProviderList;
const CasinoGamePreviewSimple = _ref => {
  var _cmsProviderList$find;
  let {
    gameModel
  } = _ref;
  const {
    liveData
  } = useLiveData(gameModel);
  const {
    latestSearchQuery
  } = useSearchResults();
  const {
    isFavorite,
    toggleFavorite,
    isPending,
    isLoggedIn
  } = useFavorites();
  const [loadingType, setLoadingType] = useState(null);
  const {
    title,
    provider,
    rtp,
    winLines,
    freePlayAllowed,
    name
  } = gameModel;
  const handleFavoriteClick = async () => {
    if (!isLoggedIn) {
      svs.components.customer_login.login();
      return;
    }
    await toggleFavorite(name);
  };
  const isFav = isFavorite(name);
  const providerModel = cmsProviderList === null || cmsProviderList === void 0 || (_cmsProviderList$find = cmsProviderList.find(item => item.model.provider === provider)) === null || _cmsProviderList$find === void 0 ? void 0 : _cmsProviderList$find.model;
  const providerPath = "".concat(urlMapping.get('casinoProvider'), "/").concat(providerModel === null || providerModel === void 0 ? void 0 : providerModel.systemName);
  const handleClick = async (e, playType) => {
    e.preventDefault();
    setLoadingType(playType);
    const currentIndex = '';
    if (latestSearchQuery) {
      dispatchGameToLastSearched("".concat(CardType.GAME, "_").concat(gameModel.name));
    }
    try {
      const canPlay = await startGameAsync(playType, gameModel.name, {
        name: gameModel.name,
        title: "".concat(gameModel.name, ";").concat(currentIndex),
        position: "".concat(getAnalyticsPosition({
          isSearched: Boolean(latestSearchQuery)
        }), ";").concat(gameModel.name)
      }, gameModel, Boolean(latestSearchQuery));
      if (!canPlay) {
        setLoadingType(null);
      }
    } catch (_unused) {
      setLoadingType(null);
    }
  };
  return React.createElement(CardBody, {
    className: "casino-game-preview-simple"
  }, React.createElement("div", {
    className: "casino-game-preview-simple__icons-wrapper"
  }, React.createElement("a", {
    "aria-label": "L\xE4s mer om ".concat(title),
    href: "".concat(urlMapping.get('casinoGameInfo'), "/").concat(name),
    tabIndex: -1,
    title: "L\xE4s mer om ".concat(title)
  }, React.createElement(IconButton, {
    tabIndex: -1
  }, React.createElement(Icon, {
    color: "icon-inverted",
    icon: "information",
    size: "300"
  }))), React.createElement(IconButton, {
    "aria-label": isFav ? 'Ta bort från favoriter' : 'Lägg till i favoriter',
    className: "casino-game-preview-simple__favorite-button",
    disabled: isPending,
    onClick: handleFavoriteClick,
    tabIndex: -1,
    title: isFav ? 'Ta bort från favoriter' : 'Lägg till i favoriter'
  }, React.createElement(Icon, {
    color: "icon-inverted",
    icon: isFav ? 'favorites-filled' : 'favorites',
    size: "300"
  }))), React.createElement("div", {
    className: "casino-game-preview-simple__title-wrapper"
  }, React.createElement("h3", {
    className: "casino-game-preview-simple__title"
  }, title), providerModel !== null && providerModel !== void 0 && providerModel.systemName ? React.createElement(Link, {
    className: "game-preview-body__provider-link",
    tabIndex: -1,
    title: "Visa spel fr\xE5n ".concat(providerModel === null || providerModel === void 0 ? void 0 : providerModel.provider),
    to: providerPath
  }, providerModel === null || providerModel === void 0 ? void 0 : providerModel.provider) : React.createElement("span", null, gameModel === null || gameModel === void 0 ? void 0 : gameModel.provider)), React.createElement("ul", null, rtp > 0 && React.createElement("li", null, "RTP:", ' ', React.createElement("span", {
    className: "casino-game-preview-simple__list-text"
  }, rtp, "%")), winLines > 0 && React.createElement("li", null, "Vinstlinjer:", ' ', React.createElement("span", {
    className: "casino-game-preview-simple__list-text"
  }, winLines, ' ', "st")), React.createElement(CasinoGamePlayers, {
    gameModel: gameModel,
    liveData: liveData
  })), React.createElement("div", {
    className: "casino-game-preview-simple__button-group"
  }, freePlayAllowed && React.createElement(Button, {
    disabled: Boolean(loadingType),
    href: "".concat(urlMapping.get('casinoDemoPlay'), "/").concat(name),
    inverted: true,
    onClick: e => handleClick(e, CasinoGamePlayTypes.demoPlay),
    tabIndex: -1,
    title: "Provspela ".concat(title),
    transparent: true,
    type: "button"
  }, loadingType === CasinoGamePlayTypes.demoPlay ? React.createElement(Loader, {
    size: 200
  }) : 'Provspela'), React.createElement(Button, {
    disabled: Boolean(loadingType),
    href: "".concat(urlMapping.get('casinoGamePlay'), "/").concat(name),
    onClick: e => handleClick(e, CasinoGamePlayTypes.gamePlay),
    tabIndex: -1,
    title: "Spela ".concat(title),
    type: "button"
  }, loadingType === CasinoGamePlayTypes.gamePlay ? React.createElement(Loader, {
    inverted: true,
    size: 200
  }) : 'Spela')));
};
setGlobal('svs.components.casino_react.casinoGamePreviewSimple.CasinoGamePreviewSimple', CasinoGamePreviewSimple);

 })(window);